var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlackHor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e30613;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    className: "cls-2",
    d: "M62.6,0v22.4h9.7v38h19.4V0h-29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    className: "cls-1",
    d: "M67.9,60.4L45.8,0h-20.1l15.4,42.2h-14.4l7.2-19.8H13.8L0,60.4h20.1l2-5.5h23.7l2.1,5.5h20.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    d: "M0,67.7h7v2H2.4v1.3h4.2v1.8H2.4v1.3h4.7v2H0v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    d: "M8.7,67.7h2.4v6.4h4.2v2h-6.6v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    d: "M16.3,67.7h7v2h-4.6v1.3h4.2v1.8h-4.2v1.3h4.7v2h-7v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    d: "M24.4,71.9h0c0-2.5,2-4.4,4.4-4.4,0,0,.1,0,.2,0,1.4,0,2.8.6,3.7,1.8l-1.8,1.4c-.4-.6-1.1-1-1.9-1-1.2,0-2.1,1-2.1,2.1,0,0,0,0,0,0h0c0,1.2.8,2.2,2,2.3,0,0,0,0,.1,0,.8,0,1.5-.4,2-1l1.8,1.3c-.9,1.3-2.3,2-3.8,1.9-2.4,0-4.4-1.8-4.5-4.2,0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    d: "M36.1,69.7h-2.6v-2h7.6v2h-2.6v6.4h-2.4v-6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    d: "M42.2,67.7h4.1c1,0,2,.2,2.8.9.5.5.8,1.2.8,2h0c0,1.2-.7,2.2-1.8,2.6l2.1,2.9h-2.8l-1.7-2.6h-1.1v2.6h-2.4v-8.4ZM46.2,71.7c.8,0,1.3-.4,1.3-1h0c0-.7-.5-1-1.3-1h-1.6v2h1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    d: "M50.8,71.9h0c.2-2.6,2.4-4.6,5-4.4,2.3.1,4.2,2,4.4,4.4h0c-.2,2.6-2.4,4.6-5,4.4-2.3-.1-4.2-2-4.4-4.4ZM57.7,71.9h0c0-1.3-.9-2.3-2.2-2.3,0,0,0,0,0,0-1.2,0-2.2,1-2.2,2.2,0,0,0,0,0,0h0c0,1.2.9,2.3,2.2,2.3,0,0,0,0,0,0,1.2,0,2.2-.9,2.2-2.2,0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    d: "M61.6,67.7h2.2l3.6,4.5v-4.5h2.4v8.4h-2.1l-3.7-4.6v4.6h-2.4v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    d: "M71.7,67.7h2.4v8.4h-2.4v-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    d: "M75.5,71.9h0c0-2.5,2-4.4,4.4-4.4,0,0,.1,0,.2,0,1.4,0,2.8.6,3.7,1.8l-1.8,1.4c-.4-.6-1.1-1-1.9-1-1.2,0-2.1,1-2.1,2.1,0,0,0,0,0,0h0c0,1.2.8,2.2,2,2.3,0,0,0,0,.1,0,.8,0,1.5-.4,2-1l1.8,1.3c-.9,1.3-2.3,2-3.8,1.9-2.4,0-4.4-1.8-4.5-4.2,0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    d: "M84.5,74.8l1.3-1.6c.8.6,1.8,1,2.8,1,.6,0,1-.2,1-.6h0c0-.4-.3-.6-1.5-.8-1.8-.4-3.3-.9-3.3-2.7h0c0-1.6,1.3-2.7,3.4-2.7,1.3,0,2.5.3,3.6,1.1l-1.2,1.7c-.7-.5-1.6-.8-2.4-.8-.6,0-.9.2-.9.5h0c0,.4.3.6,1.5.8,2,.4,3.2,1,3.2,2.6h0c0,1.7-1.4,2.8-3.5,2.8-1.5,0-2.9-.5-4.1-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    d: "M0,81.4h.4l3.3,4.9v-4.9h.4v5.5h-.4l-3.3-4.9v4.9H0v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    d: "M9.4,81.4h3.5v.3h-3.1v2.2h2.6v.3h-2.6v2.3h3.1v.3h-3.5v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    d: "M19.1,81.8h-1.8v-.3h4v.3h-1.8v5.1h-.4v-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    d: "M26,81.4h.4v2.5h3.2v-2.5h.4v5.5h-.4v-2.6h-3.2v2.6h-.4v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    d: "M35.3,81.4h3.5v.3h-3.1v2.2h2.7v.3h-2.7v2.3h3.1v.3h-3.5v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    d: "M47.7,86.9h-.4l-1.3-2.3h-1.8v2.3h-.4v-5.5h2.6c.8,0,1.2.4,1.2,1.1v.9c0,.6-.3,1.1-.9,1.1,0,0-.2,0-.3,0l1.3,2.3ZM46.3,84.3c.6,0,.8-.2.8-.8v-.9c0-.5-.2-.8-.8-.8h-2.2v2.5h2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    d: "M52.6,81.4h.4v5.1h2.9v.3h-3.3v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    d: "M63.9,85.3h-2.6l-.6,1.6h-.4l2.1-5.5h.4l2.1,5.5h-.4l-.6-1.6ZM63.7,85l-1.2-3.1-1.2,3.1h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    d: "M69.6,81.4h.4l3.3,4.9v-4.9h.4v5.5h-.4l-3.3-4.9v4.9h-.4v-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    d: "M79,81.4h2.7c.8,0,1.2.4,1.2,1.1v3.2c0,.8-.4,1.1-1.2,1.1h-2.7v-5.5ZM81.7,86.6c.6,0,.8-.2.8-.8v-3.2c0-.5-.2-.8-.8-.8h-2.3v4.8h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    d: "M87.8,85.8v-.5h.4v.5c0,.5.2.8.8.8h1.4c.6,0,.8-.2.8-.8v-.6c0-.4-.2-.6-.7-.7l-1.7-.4c-.7-.2-1.1-.4-1.1-1.1v-.4c0-.8.4-1.1,1.2-1.1h1.4c.8,0,1.2.4,1.2,1.1v.4h-.4v-.4c0-.5-.2-.8-.8-.8h-1.3c-.6,0-.8.2-.8.8v.4c0,.4.2.6.7.7l1.7.4c.7.2,1.1.4,1.1,1.1v.6c0,.8-.4,1.1-1.2,1.1h-1.5c-.8,0-1.2-.4-1.2-1.1Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.7,
    y1: 0,
    x2: 121.7,
    y2: 88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.5,38.5c1.5,1.4,2.2,3.3,2.2,5.4s-.7,3.9-2.2,5.4c-1.4,1.4-3.2,2.2-5.3,2.2s-5.1-1.4-6.2-3.7v9.2h-1.4v-20.3h1.4v3.4c1.2-2.3,3.5-3.7,6.2-3.7,2.1,0,3.9.7,5.3,2.2ZM159.1,50.1c1.7,0,3.2-.6,4.4-1.8s1.8-2.7,1.8-4.4-.6-3.2-1.8-4.4-2.6-1.8-4.4-1.8-3.2.6-4.4,1.8-1.8,2.7-1.8,4.4.6,3.2,1.8,4.4,2.7,1.8,4.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,36.6h1.5v14.5h-1.5v-3.3c-1.3,2.2-3.5,3.6-6.2,3.6s-3.8-.7-5.3-2.2c-1.5-1.5-2.2-3.3-2.2-5.4s.7-3.9,2.2-5.4c1.5-1.5,3.3-2.2,5.3-2.2s5,1.4,6.2,3.6v-3.3ZM176.9,50.1c1.7,0,3.2-.6,4.4-1.8s1.8-2.7,1.8-4.4-.6-3.2-1.8-4.4-2.6-1.8-4.4-1.8-3.2.6-4.4,1.8-1.8,2.7-1.8,4.4.6,3.2,1.8,4.4c1.2,1.2,2.7,1.8,4.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.4,39.5c.9-2,2.5-3.1,4.8-3.1v1.4c-2.8,0-4.8,1.8-4.8,5.3v8.1h-1.4v-14.5h1.4v2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.8,38h-4.3v9.4c0,2.5,1.4,2.6,4.3,2.4v1.3c-3.9.6-5.8-.4-5.8-3.7v-9.4h-3.2v-1.4h3.2v-3.6l1.5-.4v4.1h4.3v1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,49.3c-1.5-1.5-2.2-3.3-2.2-5.4s.7-3.9,2.2-5.4c1.5-1.5,3.3-2.2,5.4-2.2s3.9.7,5.4,2.2c1.5,1.4,2.2,3.3,2.2,5.4s-.8,3.9-2.2,5.4c-1.5,1.4-3.3,2.2-5.4,2.2s-3.9-.7-5.4-2.2ZM223.7,50.1c1.7,0,3.2-.6,4.4-1.8s1.8-2.7,1.8-4.4-.6-3.2-1.8-4.4-2.6-1.8-4.4-1.8-3.2.6-4.4,1.8-1.8,2.7-1.8,4.4.6,3.2,1.8,4.4c1.2,1.2,2.7,1.8,4.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1,31.9c-2.9-.2-4.3,1.1-4.3,4v.8h4.3v1.4h-4.3v13.1h-1.5v-13.1h-2.5v-1.4h2.5v-.8c0-3.6,2.1-5.6,5.8-5.4v1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.2,42.2v8.9h-4.4v-8.5c0-1.4-.7-2.4-2.1-2.4s-2.3,1-2.3,2.7v8.2h-4.4v-8.5c0-1.4-.7-2.4-2.1-2.4s-2.3,1-2.3,2.7v8.2h-4.4v-14.5h4.4v1.3c.7-1,2-1.7,3.9-1.7s3,.7,3.8,1.9c.8-1.2,2.1-1.9,4.2-1.9,3.3,0,5.5,2.4,5.5,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.6,47.7c1.2,0,2.2-.5,2.8-1.1l3.5,2c-1.4,2-3.6,3-6.3,3-5,0-8.1-3.3-8.1-7.7s3.1-7.7,7.7-7.7,7.4,3.3,7.4,7.7,0,1.2-.2,1.7h-10.3c.6,1.5,1.9,2,3.5,2ZM285.3,42.4c-.5-1.7-1.8-2.3-3.1-2.3s-2.8.8-3.2,2.3h6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.2,40.8v5.1c0,1.3,1.1,1.4,3,1.3v4c-5.7.6-7.4-1.1-7.4-5.2v-5.1h-2.3v-4.2h2.3v-2.8l4.4-1.3v4.1h3v4.2s-3,0-3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.2,32.7c0-1.4,1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6-1.2,2.6-2.6,2.6c-1.4,0-2.6-1.2-2.6-2.6ZM302.6,36.6h4.4v14.5h-4.4v-14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3,46.8c0,3.3-2.9,4.8-6,4.8s-5.1-1.1-6.2-3.5l3.8-2.1c.4,1.1,1.2,1.7,2.5,1.7s1.6-.3,1.6-.9c0-1.6-7.1-.8-7.1-5.8s2.7-4.8,5.7-4.8,4.4,1,5.7,3.1l-3.7,2c-.4-.8-1-1.3-2-1.3s-1.2.3-1.2.8c0,1.6,7.1.5,7.1,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8,36.6v13.8c0,4.9-3.8,6.9-7.7,6.9s-5.5-1.1-6.9-3.5l3.7-2.1c.6,1,1.4,1.8,3.3,1.8s3.3-1,3.3-3.1v-1.3c-1,1.2-2.4,1.9-4.2,1.9-4.1,0-7.1-3.4-7.1-7.4s3-7.4,7.1-7.4,3.3.7,4.2,1.9v-1.5h4.2ZM341.6,43.6c0-2-1.4-3.4-3.5-3.4s-3.5,1.4-3.5,3.4,1.4,3.4,3.5,3.4,3.5-1.4,3.5-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.7,36.3v4.9c-1.8-.3-4.4.4-4.4,3.3v6.6h-4.4v-14.5h4.4v2.6c.6-2,2.5-2.9,4.4-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,43.9c0-4.3,3.4-7.7,7.7-7.7s7.7,3.3,7.7,7.7-3.4,7.7-7.7,7.7-7.7-3.3-7.7-7.7ZM369.6,43.9c0-2.1-1.4-3.4-3.3-3.4s-3.3,1.4-3.3,3.4,1.4,3.4,3.3,3.4,3.3-1.4,3.3-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.2,36.6v14.5h-4.4v-1.4c-.8,1.1-2.2,1.8-4.2,1.8-2.9,0-5.4-2.1-5.4-6v-8.9h4.4v8.3c0,1.8,1.1,2.6,2.5,2.6s2.7-.9,2.7-3v-7.9h4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,43.9c0,4.3-3.1,7.7-6.9,7.7s-3.4-.7-4.3-1.8v7.2h-4.4v-20.3h4.4v1.4c1-1.1,2.4-1.8,4.3-1.8,3.8,0,6.9,3.3,6.9,7.7ZM404.7,43.9c0-2.2-1.4-3.5-3.5-3.5s-3.5,1.4-3.5,3.5,1.4,3.5,3.5,3.5,3.5-1.4,3.5-3.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlackHor);
export default __webpack_public_path__ + "static/media/logo_black_hor.403c4b9ef7e199d260c57b1b7ca38426.svg";
export { ForwardRef as ReactComponent };